<template>
  <b-form>
    <ValidationObserver ref="observer" slim>
      <b-form-row>
        <b-col cols="12" md="6">
          <ValidationProvider name="Owned Acres" rules="required" v-slot="{ errors }">
            <b-form-group
              label-cols="12"
              content-cols="12"
              label-for="ownershipAcresClass">
              <template v-slot:label>
                <span class="req-ind">*</span>How many acres does this Landowner own in Maine?
              </template>
              <b-form-radio-group
                id="ownershipAcresClass"
                name="ownershipAcresClass"
                v-model="ownershipAcresClassId"
                :aria-describedby="$errorsIdString(errors, 'ownershipAcresClass')"
                :disabled="mfsAdmin"
                stacked
              >
                <b-form-radio
                  class="mb-2"
                  v-for="option in acresClassOptions"
                  :key="option.id"
                  :value="option.id"
                  :id="`ownershipAcresClass-${option.id}`"
                >
                  <span class="sr-only">How many acres does this Landowner own in Maine?</span>
                  {{option.name}}
                </b-form-radio>
              </b-form-radio-group>
              <InputErrors
                :errors="errors"
                errorsIdPrefix="ownershipAcresClass"
                class="d-block invalid-feedback"
              />
            </b-form-group>
          </ValidationProvider>
        </b-col>
        <b-col cols="12" md="6">
          <ValidationProvider name="Ownership Type" rules="required" v-slot="{ errors }">
            <b-form-group
              label-cols="12"
              content-cols="12"
              label-for="ownershipType">
              <template v-slot:label>
                <span class="req-ind">*</span>What is this Landowner's Ownership Type?
              </template>
              <b-form-radio-group
                id="ownershipType"
                name="ownershipType"
                v-model="ownershipTypeId"
                :aria-describedby="$errorsIdString(errors, 'ownershipType')"
                :disabled="mfsAdmin"
                stacked
              >
                <b-form-radio
                  class="mb-2"
                  v-for="option in ownershipTypeOptions"
                  :key="option.id"
                  :value="option.id"
                  :id="`ownershipType-${option.id}`"
                >
                  <b-row no-gutters>
                    <b-col cols="11" lg="auto">
                      <span class="sr-only">
                        What is this Landowner's Ownership Type?
                      </span>
                      {{option.name}}
                    </b-col>
                    <b-col cols="1">
                      <FontAwesomeIcon
                        class="mx-2 text-primary"
                        size="lg"
                        icon="info-circle"
                        :id="`${option.id}-popover`"
                      />
                      <b-popover
                        :target="`${option.id}-popover`"
                        triggers="hover"
                        placement="right">
                        {{option.description}}
                      </b-popover>
                    </b-col>
                  </b-row>
                </b-form-radio>
              </b-form-radio-group>
              <InputErrors
                :errors="errors"
                errorsIdPrefix="ownershipType"
                class="d-block invalid-feedback"
              />
            </b-form-group>
          </ValidationProvider>
        </b-col>
      </b-form-row>
    </ValidationObserver>
  </b-form>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import LookupModules from '@/store/moduleConfig';
import FormSubmit from '@/mixins/FormSubmit';

export default {
  name: 'OwnershipForm',
  mixins: [FormSubmit],
  props: {
    notification: {
      type: Object,
      data() {
        return {
          ownershipAcresClassId: null,
          ownershipTypeId: null,
        };
      },
    },
  },
  data() {
    const ownership = {
      ownershipAcresClassId: null,
      ownershipTypeId: null,
    };
    if (this.notification) Object.assign(ownership, this.notification);
    return {
      ...ownership,
    };
  },
  created() {
    this.$store.dispatch(`${LookupModules.OWNERSHIP_TYPES.namespace}/fetchOptions`);
    this.$store.dispatch(`${LookupModules.ACRES_CLASSES.namespace}/fetchOptions`);
  },
  computed: {
    ...mapState(LookupModules.ACRES_CLASSES.namespace, {
      acresClassOptions: state => state.options,
      acresClassOptionsLoading: state => state.loading,
    }),
    ...mapState(LookupModules.OWNERSHIP_TYPES.namespace, {
      ownershipTypeOptions: state => state.options,
      ownershipTypeOptionsLoading: state => state.loading,
    }),
    ...mapGetters('User', ['mfsAdmin']),
  },
  methods: {
    async submitWrapper() {
      if (this.mfsAdmin) {
        return true;
      }
      return this.submit(
        this.$refs.observer,
        'Notification/updateOwnership',
        this.$data,
      );
    },
  },
};
</script>
